export default __webpack_public_path__ + "static/media/cancel-dark.c1f87996.svg";